import { makeStyles, tokens } from "@fluentui/react-components";

export const useStyles = makeStyles({
    compoundButton: {
        justifyContent: 'start',
        boxShadow: tokens.shadow4,
        border: 'none',
        '& .fui-CompoundButton__secondaryContent': {
            color: tokens.colorNeutralForeground3
        },
        '&:hover .fui-CompoundButton__secondaryContent': {
            color: tokens.colorNeutralForeground2
        }
    },
    compoundButtonChecked: {
        backgroundColor: tokens.colorSubtleBackgroundSelected,
        color: tokens.colorCompoundBrandForeground1,
        justifyContent: 'start',
        boxShadow: tokens.shadow4,
        border: 'none',
        '& .fui-CompoundButton__secondaryContent': {
            color: tokens.colorCompoundBrandForeground1
        },
        '&:hover': {
            backgroundColor: tokens.colorSubtleBackgroundSelected,
            color: tokens.colorCompoundBrandForeground1
        },
        '&:hover .fui-CompoundButton__secondaryContent': {
            color: tokens.colorCompoundBrandForeground1
        }
    },
    checkBox: {
        width: '64px',
        height: '64px',
        marginInline: '-12px'
    },
})